import * as fs from "fs";
import util, { promisify } from "util";

const statAsync = promisify(fs.stat);

export async function isDirectoryExists(directoryPath: string): Promise<boolean> {
    try {
        const dirStat = await statAsync(directoryPath);
        return dirStat.isDirectory();
    } catch {
        return false;
    }
}

export async function isFileExists(directoryPath: string): Promise<boolean> {
    try {
        const dirStat = await statAsync(directoryPath);
        return dirStat.isFile();
    } catch {
        return false;
    }
}

export const writeFileAsync = util.promisify(fs.writeFile);

export type GlobAsyncWithoutFileTypes = (
    pattern: string | string[],
    options?: fs.GlobOptionsWithoutFileTypes
) => Promise<string[]>;
export const globAsync: GlobAsyncWithoutFileTypes = promisify(fs.glob);
